import React, { useState, useEffect } from 'react';
import { BiSearch } from 'react-icons/bi'

import { useSpotify } from '../../hoc/context/SpotifyContextContainer'
import { makeSpotifyRequest } from '../../config/SpotifyRequests'

import  SearchItem from './searchResults/SearchItem'

const SearchBar = () => {

    const { accessToken } = useSpotify()
    const [queryParams, setQueryParams] = useState('');
    const [result, setResult] = useState([])

    const spaceFunc = (event) => {
        if(event.keyCode === 27) {
            setQueryParams('')
          }
      }
    useEffect(async () => {
        if(queryParams.length < 3) return setResult([])
        try {

            const url = `https://api.spotify.com/v1/search?type=playlist&q=${encodeURI(queryParams)}`
            const data  = (await makeSpotifyRequest(url, accessToken)).data
            setResult([...data.playlists.items])

        }catch(e){

        }
    }, [queryParams])

    useEffect(()=> {
        document.addEventListener("keydown", spaceFunc, false);
        return () => { document.removeEventListener("keydown", spaceFunc, false) };
        }, [])

    const renderItems = (items) => {
        return items.map((item, i) => (
            <SearchItem  key={i} item={item}/>
        ))
    }

    return (
        <>
        <div className="searchbar">
            <input className="searchbar__input" type="text" placeholder="Search for new playlists..." value={queryParams} onChange={(e) => setQueryParams(e.target.value)}/>
            <BiSearch className="searchbar__icon" size="20"/>
        </div>
        {
                result.length > 0 && (
                    <div className="search__results">
                        {renderItems(result)}
                    </div>

                    )
            }
        </>            
    );
}

export default SearchBar;
